import { MyrAPIService } from '../../../api/myr/myrAPI';
import { MyrAPIEndpoints } from '../../../api/myr/myrAPIEndpoints.constant';
import { IChallengeData } from '../../../utils/challengerMain';

export interface IDsrDeleteRequest {
    serviceUuid: string;
    challengeData?: IChallengeData;
}

export function createDsrDeleteRequest<T>(
    body: IDsrDeleteRequest,
    credentials: string,
): Promise<T> {
    return MyrAPIService.sendRequest(MyrAPIEndpoints.SERVICE_DELETE, 'DELETE', body, credentials);
}
